import script from "./Subscribe.vue?vue&type=script&setup=true&lang=ts"
export * from "./Subscribe.vue?vue&type=script&setup=true&lang=ts"

import "./Subscribe.vue?vue&type=style&index=0&id=2cf478bc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf478bc"]])